export const naa: { label: string; value: string; shortnanme?: string }[] = [
    { label: "A (Ala)", value: "A", shortnanme: "Ala" },
    { label: "R (Arg)", value: "R", shortnanme: "Arg" },
    { label: "N (Asn)", value: "N", shortnanme: "Asn" },
    { label: "D (Asp)", value: "D", shortnanme: "Asp" },
    { label: "C (Cys)", value: "C", shortnanme: "Cys" },
    { label: "Q (Gln)", value: "Q", shortnanme: "Gln" },
    { label: "E (Glu)", value: "E", shortnanme: "Glu" },
    { label: "G (Gly)", value: "G", shortnanme: "Gly" },
    { label: "H (His)", value: "H", shortnanme: "His" },
    { label: "I (Ile)", value: "I", shortnanme: "Ile" },
    { label: "L (Leu)", value: "L", shortnanme: "Leu" },
    { label: "K (Lys)", value: "K", shortnanme: "Lys" },
    { label: "M (Met)", value: "M", shortnanme: "Met" },
    { label: "F (Phe)", value: "F", shortnanme: "Phe" },
    { label: "P (Pro)", value: "P", shortnanme: "Pro" },
    { label: "S (Ser)", value: "S", shortnanme: "Ser" },
    { label: "T (Thr)", value: "T", shortnanme: "Thr" },
    { label: "W (Trp)", value: "W", shortnanme: "Trp" },
    { label: "Y (Tyr)", value: "Y", shortnanme: "Tyr" },
    { label: "V (Val)", value: "V", shortnanme: "Val" },
    { label: "* (TERM)", value: "*" },
];

export const codons: { [name: string]: { label: string; value: string; codon: string[]; fullname: string; shortnanme: string } } = {
    "A": { label: "Ala", value: "A", codon: ["GCT", "GCC", "GCA", "GCG"], fullname: "Alanine", shortnanme: "Ala" },
    "R": { label: "Arg", value: "R", codon: ["CGT", "CGC", "CGA", "CGG", "AGA", "AGG"], fullname: "Arginine", shortnanme: "Arg" },
    "N": { label: "Asn", value: "N", codon: ["AAT", "AAC"], fullname: "Asparagine", shortnanme: "Asn" },
    "D": { label: "Asp", value: "D", codon: ["GAT", "GAC"], fullname: "Aspartic acid", shortnanme: "Asp" },
    "C": { label: "Cys", value: "C", codon: ["TGT", "TGC"], fullname: "Cysteine", shortnanme: "Cys" },
    "Q": { label: "Gln", value: "Q", codon: ["CAA", "CAG"], fullname: "Glutamine", shortnanme: "Gln" },
    "E": { label: "Glu", value: "E", codon: ["GAA", "GAG"], fullname: "Glutamic acid", shortnanme: "Glu" },
    "G": { label: "Gly", value: "G", codon: ["GGT", "GGC", "GGA", "GGG"], fullname: "Glycine", shortnanme: "Gly" },
    "H": { label: "His", value: "H", codon: ["CAT", "CAC"], fullname: "Histidine", shortnanme: "His" },
    "I": { label: "Ile", value: "I", codon: ["ATT", "ATC", "ATA"], fullname: "Isoleucine", shortnanme: "Ile" },
    "L": { label: "Leu", value: "L", codon: ["CTT", "CTC", "CTA", "CTG", "TTA", "TTG"], fullname: "Leucine", shortnanme: "Leu" },
    "K": { label: "Lys", value: "K", codon: ["AAA", "AAG"], fullname: "Lysine", shortnanme: "Lys" },
    "M": { label: "Met", value: "M", codon: ["ATG"], fullname: "Methionine", shortnanme: "Met" },
    "F": { label: "Phe", value: "F", codon: ["TTT", "TTC"], fullname: "Phenylalanine", shortnanme: "Phe" },
    "P": { label: "Pro", value: "P", codon: ["CCT", "CCC", "CCA", "CCG"], fullname: "Proline", shortnanme: "Pro" },
    "S": { label: "Ser", value: "S", codon: ["TCT", "TCC", "TCA", "TCG", "AGT", "AGC"], fullname: "Serine", shortnanme: "Ser" },
    "T": { label: "Thr", value: "T", codon: ["ACT", "ACC", "ACA", "ACG"], fullname: "Threonine", shortnanme: "Thr" },
    "W": { label: "Trp", value: "W", codon: ["TGG"], fullname: "Tryptophan", shortnanme: "Trp" },
    "Y": { label: "Tyr", value: "Y", codon: ["TAT", "TAC"], fullname: "Tyrosine", shortnanme: "Tyr" },
    "*": { label: "TERM", value: "*", codon: ["TAA", "TAG", "TGA"], fullname: "Termination codon", shortnanme: "TERM" },
    "V": { label: "Val", value: "V", codon: ["GTT", "GTC", "GTA", "GTG"], fullname: "Valine", shortnanme: "Val" },
};

export const codonDict: { [name: string]: string } = {
    TTT: "F",
    TTC: "F",
    TTA: "L",
    TTG: "L",
    CTT: "L",
    CTC: "L",
    CTA: "L",
    CTG: "L",
    AGT: "S",
    AGC: "S",
    TCT: "S",
    TCC: "S",
    TCA: "S",
    TCG: "S",
    TAT: "Y",
    TAC: "Y",
    TGT: "C",
    TGC: "C",
    CCT: "P",
    CCC: "P",
    CCA: "P",
    CCG: "P",
    CAT: "H",
    CAC: "H",
    CAA: "Q",
    CAG: "Q",
    AGA: "R",
    AGG: "R",
    CGT: "R",
    CGC: "R",
    CGA: "R",
    CGG: "R",
    ATT: "I",
    ATC: "I",
    ATA: "I",
    ACT: "T",
    ACC: "T",
    ACA: "T",
    ACG: "T",
    AAT: "N",
    AAC: "N",
    AAA: "K",
    AAG: "K",
    GTT: "V",
    GTC: "V",
    GTA: "V",
    GTG: "V",
    GCT: "A",
    GCC: "A",
    GCA: "A",
    GCG: "A",
    GAT: "D",
    GAC: "D",
    GAA: "E",
    GAG: "E",
    GGT: "G",
    GGC: "G",
    GGA: "G",
    GGG: "G",
    TGG: "W",
    ATG: "M",
    TAA: "*",
    TAG: "*",
    TGA: "*",
};
